export default __webpack_public_path__ + "static/media/SomethingAboutYou60s.ecc6e471.mp3";